// extracted by mini-css-extract-plugin
export var attribution = "_d9-4";
export var authorName = "_d9-5";
export var quote = "_d9-3";
export var testimonial = "_d9-2";
export var trustedBy = "_d9-0";
export var trustedByLabel = "_d9-1";